import { render } from "./DirectoryChildrenTable.vue?vue&type=template&id=195c8b79"
import script from "./DirectoryChildrenTable.vue?vue&type=script&lang=js"
export * from "./DirectoryChildrenTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__